import { OVERLAP_FAILURE_SENTENCES } from "../constants/copy";

export type OverlapRecognizeReason =
  | "blurry"
  | "cropped"
  | "no_positions"
  | "not_holdings";

export type OverlapFailureKind =
  | { kind: "recognize"; reason: OverlapRecognizeReason }
  | { kind: "compute_error" };

/** 弯撇号统一成直撇号、收尾空白：PRD 与设计稿的撇号弯 / 直混用（O-11），两种都要命中。 */
const normalize = (text: string): string => text.replace(/[‘’]/g, "'").trim();

const RECOGNIZE_REASONS: readonly OverlapRecognizeReason[] = [
  "blurry",
  "cropped",
  "no_positions",
  "not_holdings",
];

/**
 * 识别重叠分析的失败消息（EDG-561 SC-12 / SC-14）。
 *
 * **识别只用于上报**（`overlap_reupload_sent` / `overlap_result_retry`），识别不到不影响任何展示。
 * 用 `startsWith`（识别失败）/ `includes`（计算失败）而不是整句相等：话术后面还会接
 * `Tap + below and send me a new one.` 之类的引导句。
 */
export const detectOverlapFailureKind = (
  content: string,
): OverlapFailureKind | null => {
  const text = normalize(content ?? "");
  if (!text) {
    return null;
  }
  for (const reason of RECOGNIZE_REASONS) {
    if (text.startsWith(OVERLAP_FAILURE_SENTENCES[reason])) {
      return { kind: "recognize", reason };
    }
  }
  if (text.includes(OVERLAP_FAILURE_SENTENCES.computeError)) {
    return { kind: "compute_error" };
  }
  return null;
};
